<cm-password-change (submit)="submit($event)" (close)="closePopup()" (cancel)="closePopup()" [disabled]="disableForm"></cm-password-change>

<div class="submission-message">{{ message }}</div>
